import CollapsibleSplitterExample from "./examples/Splitter.Collapsible.Example";
import SplitterExample from "./examples/Splitter.Example";
import HorizontalSplitterExample from "./examples/Splitter.Horizontal.Example";

export default [
    {
        title: "Basic splitter",
        component: SplitterExample,
        code: require("!raw-loader!./examples/Splitter.Example.tsx"),
        stretchContainer: true,
    },
    {
        title: "Collapsible splitter",
        component: CollapsibleSplitterExample,
        code: require("!raw-loader!./examples/Splitter.Collapsible.Example.tsx"),
        stretchContainer: true,
    },
    {
        title: "Horizontal splitter",
        component: HorizontalSplitterExample,
        code: require("!raw-loader!./examples/Splitter.Horizontal.Example.tsx"),
        stretchContainer: true,
    },
];
